// extracted by mini-css-extract-plugin
export default {"main":"Collapse--main--OjsXP","header":"Collapse--header--d8YYK","collapse":"Collapse--collapse--oZOGR"};